import Configurator from './configurator.js';
import Cart from './cart.js';
import Preview from './preview.js';

const ConfiguratorForm = {

    selection: {
        wireId:       null,
        gauge:        null,
        color:        null,
        leftLugId:    null,
        leftShrinkId: null,
        rightLugId:   null,
        rightShrinkId: null,
        cartItemKey:  null,
        rightNoConnection: false,
        rightEndType:    'stripped-retained',
        rightStripLength: null,
    },

    editingCartKey: null,

    init() {

        this.resetFormInit();
        this.bindEvents();
        this.debugPreset();
    },

    resetFormInit() {
        jQuery('#color, #lefttype, #leftshrink, #righttype, #rightshrink, #go-to-right-lug, #go-to-wire, #go-to-left-lug, #go-to-left-lug-2, #go-to-right-lug-2')
            .prop('disabled', true)
            .val('');
    },

    

    populateSelect(selectId, options, valueKey, labelKey) {
        const select   = jQuery('#' + selectId);
        const emptyVal = select.attr('empty-value') || 'Select...';

        select.empty().append(`<option value="">${emptyVal}</option>`);

        options.forEach(option => {
            const value = valueKey ? option[valueKey] : option;
            const label = labelKey ? option[labelKey] : option;
            select.append(`<option value="${value}">${label}</option>`);
        });
    },

    bindEvents() {
        jQuery('#gauge').on('change', (e) => this.onGaugeChange(e.target.value));
        jQuery('#color').on('change', (e) => this.onColorChange(e.target.value));
        jQuery('#lefttype').on('change',  (e) => this.onLugChange('left',  e.target.value));
        jQuery('#righttype').on('change', (e) => this.onLugChange('right', e.target.value));
        jQuery('#leftshrink').on('change',  (e) => this.onShrinkChange('left',  e.target.value));
        jQuery('#rightshrink').on('change', (e) => this.onShrinkChange('right', e.target.value));

        jQuery( '#length' ).on( 'input change', () => {
            const length = parseFloat( jQuery( '#length' ).val() );
            const leftShrinkValue = jQuery( '#lefttype' ).val();
            
            if (leftShrinkValue != "" && length > 0) {
                return;
            }

            /*
            if ( length > 0 && this.selection.gauge ) {
                jQuery( '#color' ).prop( 'disabled', false );
            } else {
                jQuery( '#color' ).prop( 'disabled', true ).val( '' );
            }
                */

            /* Enable left lug if color is already selected */
            if ( length > 0 && this.selection.color ) {
                
                jQuery( '#lefttype' ).prop( 'disabled', false );

                // Increment step
                Configurator.currentStep = 2;
                Configurator.updatePageIndicator(2);
                Configurator.updateSlideStates(2);
                Configurator.updatePreview(this.selection);

                if (jQuery('body').hasClass('bp-mobile')) {
                    //Configurator.goToSlide(0);
                    jQuery('#go-to-left-lug-2').prop('disabled', false);
                    jQuery('#go-to-wire').prop('disabled', false);
                }

                
                // Move the selected slide bg color
                jQuery('.configurator-slide[itemid=1]').removeClass('is-current');
                jQuery('.configurator-slide[itemid=0]').addClass('is-current');

                jQuery('.number[itemid=1]').addClass('current');


            } else if ( ! length ) {
                jQuery( '#lefttype' ).prop( 'disabled', true ).val( '' );
                this.selection.leftLugId    = null;
                this.selection.rightLugId   = null;
                this.selection.leftShrinkId = null;
                this.selection.rightShrinkId = null;
                jQuery( '#righttype, #leftshrink, #rightshrink' ).prop( 'disabled', true ).val( '' );
                Configurator.updatePreview( this.selection );
            }
        } );

        jQuery('#done, #done-2').on('click', (e) => {

            e.preventDefault();

            Configurator.currentStep = 5;

            if (jQuery('body').hasClass('bp-tablet')) {
                Configurator.goToSlide(4);
            } else {

                if (jQuery('body').hasClass('bp-mobile')) {
                    Configurator.goToSlide(4);
                } else {
                    Configurator.goToSlide(3);
                }
                 
            }

            
            Configurator.updatePageIndicator(5);
            Configurator.updateSlideStates(5);

            
            jQuery('#done, #done-2').prop('disabled', true);

        });

        

        jQuery('#edit').on('click', (e) => {
            e.preventDefault();
            Configurator.currentStep = 3;
            Configurator.goToSlide(0);
            Configurator.updatePageIndicator(3);
            Configurator.updateSlideStates(3);
            jQuery('#done, #done-2').prop('disabled', false);
        });

        jQuery( '#measure' ).on( 'change', ( e ) => {
            const unit = e.target.value;
            jQuery( '.s-unit' ).text( unit );
        } );

        jQuery('#quantity').on('input change', () => {
            const qty = parseInt(jQuery('#quantity').val());
            if (qty > 0) {

                jQuery('.number[itemid=4]').addClass('current');
                jQuery('#add-to-cart').removeAttr('disabled');
            } else {

                jQuery('.number[itemid=4]').removeClass('current');
                jQuery('#add-to-cart').attr('disabled', true);
            }
        });

        jQuery('#add-to-cart').on('click', (e) => {
            e.preventDefault();
            this.onAddToCart();
        });

        jQuery('#reset').on('click', (e) => {
            e.preventDefault();
            this.resetForm();
        });

        jQuery('#build-another').on('click', (e) => {
            e.preventDefault();
            jQuery('#cable-added-to-cart').addClass('hidden');
            jQuery('#reset').removeClass('hidden');
            this.resetForm();
        });

        jQuery('#view-cart').on('click', (e) => {
            e.preventDefault();
            jQuery('body').toggleClass('cart-open');
        });

        jQuery('#submit-quote').on('click', (e) => {
            e.preventDefault();
            this.onSubmitQuote();
        });

        jQuery('#go-to-right-lug').on('click', (e) => {
            e.preventDefault();

            if (jQuery('body').hasClass('bp-mobile')) {
                Configurator.goToSlide(2);
            } else {
                Configurator.nextSlide();
            }
            
        });

        jQuery('#go-to-wire').on('click', (e) => {
            e.preventDefault();

            if (jQuery('body').hasClass('bp-mobile')) {
                Configurator.goToSlide(1);
            } else {
                Configurator.nextSlide();
            }
            
        });

        jQuery('#go-to-left-lug').on('click', (e) => {
            e.preventDefault();
            Configurator.goToSlide(0);
        });

        jQuery('#go-to-left-lug-2').on('click', (e) => {
            e.preventDefault();
            Configurator.goToSlide(0);
        });

        jQuery('#go-to-right-lug-2').on('click', (e) => {
            e.preventDefault();
            Configurator.goToSlide(2);
        });


        jQuery( '#right-end-type' ).on( 'change', ( e ) => {
            this.onRightEndTypeChange( e.target.value );
        } );
        
    },

    onShrinkChange(side, shrinkId) {
        if (side === 'left') {
            this.selection.leftShrinkId  = shrinkId ? parseInt(shrinkId) : null;
        } else {
            this.selection.rightShrinkId = shrinkId ? parseInt(shrinkId) : null;
        }

        Configurator.updatePreview(this.selection);
    },

    onRightEndTypeChange( value ) {
        this.selection.rightEndType    = value || null;
        this.selection.rightStripLength = null;

        jQuery( '#right-strip-length-row' ).toggle( value === 'stripped' || value === 'stripped-retained' );
        jQuery( '#right-strip-length' ).val( '' );
 
        Configurator.updatePreview( this.selection );
    },

    onAddToCart() {
        const length   = parseFloat(jQuery('#length').val());
        const unit     = jQuery('#measure').val();
        const quantity = parseInt(jQuery('#quantity').val());

        if ( ! quantity || quantity < 1 || quantity > 9999 ) {
            this.showFieldError( '#quantity', 'Quantity must be between 1 and 9999.' );
            return;
        }

        const checkboxes = {};
        jQuery('input[name="options[]"]').each(function() {
            checkboxes[jQuery(this).val()] = jQuery(this).is(':checked');
        });

        const payload = {
            vendor_id:           parseInt(VendorData.vendorId),
            wire_id:             this.selection.wireId,
            wire_length_inches:  length,
            wire_length_unit:    unit,
            quantity:            quantity,
            checkboxes:          checkboxes,
            left_lug_id:         this.selection.leftLugId    || null,
            left_heatshrink_id:  this.selection.leftShrinkId || null,
            right_lug_id:        this.selection.rightLugId   || null,
            right_heatshrink_id: this.selection.rightShrinkId || null,
            right_end_type:         this.selection.rightEndType      || null,
            right_strip_length:     this.selection.rightStripLength || parseFloat( jQuery( '#right-strip-length' ).val() ) || null,
        };


        const doAdd = () => {
            jQuery.ajax({
                url:         VendorData.apiBase + '/cart/add-wire-set',
                method:      'POST',
                contentType: 'application/json',
                headers:     { 'X-WP-Nonce': VendorData.restNonce ?? '' },
                xhrFields:   { withCredentials: true },
                data:        JSON.stringify(payload),
                success: (response) => {
                    if (response.success) {
                        this.cartItemKey   = response.cart_item_key;
                        this.editingCartKey = null;
                        Cart.markDirty();
                        Cart.fetchAndRender();
                        Configurator.currentStep = 7;
                        Configurator.goToSlide(7);
                        Configurator.updatePageIndicator(8);
                        Configurator.updateSlideStates(8);
                        jQuery('#cable-added-to-cart').removeClass('hidden');
                        jQuery('#reset').addClass('hidden');
                    }
                },
                error: (xhr) => {
                    console.error('Add to cart failed:', xhr.responseJSON);
                    alert(xhr.responseJSON?.message || 'Failed to add to cart.');
                },
            });
        };

        // If editing, delete old item first then add new
        if (this.editingCartKey) {
            jQuery.ajax({
                url:         VendorData.apiBase + '/cart/remove-wire-set',
                method:      'POST',
                contentType: 'application/json',
                xhrFields:   { withCredentials: true },
                headers:     { 'X-WP-Nonce': VendorData.restNonce ?? '' },
                data:        JSON.stringify({ cart_item_key: this.editingCartKey }),
                success: () => doAdd(),
                error:   () => doAdd(), // add anyway if remove fails
            });
        } else {
            doAdd();
        }
    },

    onLugChange(side, lugId) {
        const shrinkId = side === 'left' ? 'leftshrink' : 'rightshrink';
        const isNoConnection = lugId === 'no-connection';

        if (side === 'left') {
            this.selection.leftLugId    = lugId ? parseInt(lugId) : null;
            this.selection.leftShrinkId = null;

            if (lugId) {
                Configurator.currentStep = 3;
                Configurator.updatePageIndicator(3);
                Configurator.updateSlideStates(3);
                jQuery('.number[itemid=2]').addClass('current');
                jQuery('#righttype').prop('disabled', false);
                jQuery('#go-to-right-lug').prop('disabled', false);
                jQuery('#go-to-right-lug-2').prop('disabled', false);
                jQuery('#go-to-left-lug').prop('disabled', false);
                jQuery( '#leftshrink' ).val( '' ).prop( 'disabled', ! lugId );
                jQuery('.configurator-slide[itemid=2]').addClass('is-current');
                jQuery('.configurator-slide[itemid=0]').removeClass('is-current');

            } else {
                jQuery('#righttype').prop('disabled', true).val('');
                jQuery('#rightshrink').prop('disabled', true).val('');
                this.selection.rightLugId    = null;
                this.selection.rightShrinkId = null;
                jQuery('#done, #done-2').prop('disabled', true);
                jQuery('#go-to-right-lug').prop('disabled', true);
                jQuery('#go-to-right-lug-2').prop('disabled', true);
                jQuery('#go-to-left-lug').prop('disabled', true);
                jQuery('.configurator-slide[itemid=2]').removeClass('is-current');
                jQuery('.configurator-slide[itemid=0]').addClass('is-current');
            }

            if (!lugId) {
                jQuery('#' + shrinkId).prop('disabled', true).val('');
                Configurator.updatePreview(this.selection);
                return;
            }

            
            jQuery('#' + shrinkId).prop('disabled', false).focus();

        } else {

            this.selection.rightLugId    = isNoConnection ? null : ( lugId ? parseInt( lugId ) : null );
            this.selection.rightShrinkId = null;
            this.selection.rightNoConnection = isNoConnection;

            jQuery( '#right-end-type-row' ).toggle( isNoConnection );
            jQuery( '#right-strip-length-row' ).toggle( isNoConnection );
            if ( isNoConnection ) {
                jQuery( '#right-end-type' ).val( 'stripped-retained' );
                jQuery( '.s-row-heat-shrink-right' ).addClass( 'hidden' );
                this.selection.rightEndType = 'stripped-retained';
                Configurator.updatePreview( this.selection );
            } else {
                jQuery( '.s-row-heat-shrink-right' ).removeClass( 'hidden' );
            }

            
            jQuery('.number[itemid=3]').addClass('current');
            jQuery( '#rightshrink' ).val( '' ).prop( 'disabled', ! lugId || isNoConnection );

            if (lugId) {
                jQuery('#done, #done-2').prop('disabled', false);
                jQuery('.configurator-slide[itemid=0]').removeClass('is-current');
                jQuery('.configurator-slide[itemid=2]').removeClass('is-current');
            } else {
                jQuery('#done, #done-2').prop('disabled', true);
                jQuery('.configurator-slide[itemid=0]').removeClass('is-current');
                jQuery('.configurator-slide[itemid=2]').addClass('is-current');
            }
        }

        Configurator.updatePreview(this.selection);
        
    },

    onColorChange(color) {
        this.selection.wireId = null;
        this.selection.color  = color;
        this.selection.leftLugId     = null;
        this.selection.rightLugId    = null;
        this.selection.leftShrinkId  = null;
        this.selection.rightShrinkId = null;

        jQuery('#lefttype, #leftshrink, #righttype, #rightshrink, #go-to-right-lug, #go-to-wire, #go-to-left-lug')
            .prop('disabled', true)
            .val('');
        jQuery( '#right-end-type-row' ).hide();
        jQuery( '#right-strip-length-row' ).hide();
        jQuery( '.s-row-heat-shrink-right' ).removeClass( 'hidden' );
        
        if ( ! color || ! this.selection.gauge ) {
            /* Show transparent gauge preview when color is cleared */
            const sizeData = VendorData.wireSizeOptions[ this.selection.gauge ];
            if ( sizeData ) {
                const firstColor   = Object.keys( sizeData ).sort( ( a, b ) => b.localeCompare( a ) )[0];
                const firstWireData = firstColor ? sizeData[ firstColor ] : null;
                const firstWireId   = firstWireData?.ids?.[0] ?? null;
                const wire          = firstWireId ? VendorData.products.wires[ firstWireId ] : null;

                if ( wire?.model_url ) {
                    
                    Preview.currentSelection = null;
                    Configurator.updatePreview( { wireId: null } );
                    Preview.loadDefault( wire.model_url, wire.wire_edge_url, true );
                } else {
                    
                    Preview.currentSelection = null;
                    Configurator.updatePreview( { wireId: null } );
                }
            } else {
                
                Preview.currentSelection = null;
                Configurator.updatePreview( { wireId: null } );
            }
            return;
        }

        

        const sizeData = VendorData.wireSizeOptions[this.selection.gauge];
        if (!sizeData || !sizeData[color]) return;

        const wireData = sizeData[color];
        this.selection.wireId = wireData.ids[0];

        /* Preload compatible lug models in background */
        wireData.compatible_lugs.forEach( async ( lugId, i ) => {
            await new Promise( resolve => setTimeout( resolve, i * 300 ) );
            const lug = VendorData.products.lugs[ lugId ];
            if ( lug?.model_url ) Preview.loadGLTF( lug.model_url ).catch( () => {} );
        } );

        // Populate lugs
        const lugOptions = wireData.compatible_lugs.map(lugId => {
            const lug = VendorData.lugOptions[lugId];
            return lug ? { value: lug.id, label: lug.part_number } : null;
        }).filter(Boolean);

        const lugOptionsWithNoConn = [
            { value: 'no-connection', label: 'No Connection' },
            ...lugOptions,
        ];

        this.populateSelect('lefttype',  lugOptions, 'value', 'label');
        this.populateSelect('righttype', lugOptionsWithNoConn, 'value', 'label');
        

        // Populate heatshrinks
        const heatshrinkOptions = wireData.compatible_heatshrinks.map(hsId => {
            const hs = VendorData.products.heatshrinks[hsId];
            return hs ? { value: hs.id, label: hs.part_number } : null;
        }).filter(Boolean);

        this.populateSelect('leftshrink',  heatshrinkOptions, 'value', 'label');
        this.populateSelect('rightshrink', heatshrinkOptions, 'value', 'label');
        
        Configurator.updatePreview(this.selection);

        const length = parseFloat( jQuery( '#length' ).val() );
        if ( length > 0 ) {

            jQuery( '#lefttype' ).prop( 'disabled', false ).focus();

            // Increment step
            Configurator.currentStep = 2;
            Configurator.updatePageIndicator(2);
            Configurator.updateSlideStates(2);
            

            if (jQuery('body').hasClass('bp-mobile')) {
                //Configurator.goToSlide(0);
                jQuery('#go-to-left-lug-2').prop('disabled', false);
                jQuery('#go-to-wire').prop('disabled', false);
            }

            
            // Move the selected slide bg color
            jQuery('.configurator-slide[itemid=1]').removeClass('is-current');
            jQuery('.configurator-slide[itemid=0]').addClass('is-current');

            jQuery('.number[itemid=1]').addClass('current');
        } else {
            jQuery( '#length' ).focus();
        }

        
    },

    onGaugeChange(gauge) {

        this.selection.gauge  = gauge;
        this.selection.color  = null;
        this.selection.wireId = null;
        
        jQuery('#color, #lefttype, #leftshrink, #righttype, #rightshrink')
            .prop('disabled', true)
            .val('');

        jQuery( '#right-end-type-row' ).hide();
        jQuery( '#right-strip-length-row' ).hide();
        jQuery( '.s-row-heat-shrink-right' ).removeClass( 'hidden' );

        if ( ! gauge ) {
            Configurator.updatePreview( { wireId: null } );
            return;
        }

        const sizeData = VendorData.wireSizeOptions[gauge];
        if (!sizeData) return;

        const colors = Object.keys( sizeData ).sort( ( a, b ) => b.localeCompare( a ) );
        const firstColor = colors[0];
        const firstWireData = firstColor ? sizeData[ firstColor ] : null;
        const firstWireId   = firstWireData?.ids?.[0] ?? null;

        this.populateSelect('color', colors); 

        
        //reset view to nothing
        if ( firstWireId ) {
            const wire = VendorData.products.wires[ firstWireId ];
            if ( wire?.model_url ) {
                Preview.clearModels();
                Preview.currentSelection = null;
                Preview.loadDefault( wire.model_url, wire.wire_edge_url, true );
            }
        } else {
            Preview.clearModels();
            Preview.currentSelection = null;
            Configurator.updatePreview( { wireId: null } );
        }
        
        
        jQuery('#color').prop('disabled', false);
        
        
        jQuery('#color').focus();
    },

    resetForm() {
        // Reset selection state
        this.selection = {
            wireId:        null,
            gauge:         null,
            color:         null,
            leftLugId:     null,
            leftShrinkId:  null,
            rightLugId:    null,
            rightShrinkId: null,
            rightNoConnection: false,
            rightEndType: 'stripped-retained',
            rightStripLength: null,

        };

        this.editingCartKey = null;

        // Reset all fields
        jQuery('#gauge').val('');
        jQuery('#length, #quantity').val('');
        jQuery('#go-to-right-lug, #go-to-left-lug, #go-to-left-lug-2').prop('disabled', true);
        jQuery('#color, #lefttype, #leftshrink, #righttype, #rightshrink').val('').prop('disabled', true);
        jQuery('#add-to-cart, #done, #done-2').attr('disabled', true);
        jQuery( '#right-end-type' ).val( 'stripped-retained' );
        jQuery( '#right-strip-length-row' ).hide();
        jQuery( '#right-end-type-row' ).hide();
        jQuery( '#measure' ).val('in');
        jQuery( '.s-unit' ).text( jQuery( '#measure' ).val() );

        // Reset configurator state
        Configurator.currentStep = 1;

        if (jQuery('body').hasClass('bp-mobile')) {
            Configurator.goToSlide(1);
        } else {
            Configurator.goToSlide(0);
        }
        
        Configurator.updatePageIndicator(1);
        Configurator.updateSlideStates(1);
        Configurator.updatePreview({ wireId: null });
    },

    async loadFromCartItem( cartKey, data ) {
        this.resetForm();
        this.editingCartKey = cartKey;

        const wait = ( ms ) => new Promise( resolve => setTimeout( resolve, ms ) );
        

        const wirePart = data['Wire'] || null;
        const wire     = wirePart ? Object.values( VendorData.products.wires ).find( w => w.part_number === wirePart ) : null;

        if ( ! wire ) return;

        this.selection.wireId = wire.id;
        const gauge           = wire.wire_size;
        const color           = wire.jacket_color;

        const lengthRaw = data['Wire Length'] || '';
        const unit      = lengthRaw.includes( 'cm' ) ? 'cm' : 'in';
        const length    = parseFloat( lengthRaw );

        if ( length ) {
            jQuery( '#measure' ).val( unit );
            jQuery( '#length' ).val( length ).trigger( 'change' );
            await wait( 200 );
        }

        if ( gauge ) {
            jQuery( '#gauge' ).val( gauge ).trigger( 'change' );
            await wait( 300 );
        }

        if ( color ) {
            jQuery( '#color' ).val( color ).trigger( 'change' );
            await wait( 300 );
        }

        const leftLug = data['Left Lug'] || null;
        if ( leftLug ) {
            const lugId = this.findLugIdByPartNumber( leftLug );
            if ( lugId ) {
                jQuery( '#lefttype' ).val( lugId ).trigger( 'change' );
                await wait( 600 );
            }
        }

        const rightLug = data['Right Lug'] || null;
        if ( rightLug ) {
            const lugId = this.findLugIdByPartNumber( rightLug );
            if ( lugId ) {
                jQuery( '#righttype' ).val( lugId ).trigger( 'change' );
                await wait( 600 );
            }
        }else {
            /* No connection case */
            jQuery( '#righttype' ).val( 'no-connection' ).trigger( 'change' );
            await wait( 300 );

            const endType = data['Right End Treatment'] || data['Right End Type'] || null;
            if ( endType ) {
                const valueMap = {
                    'Stripped & Retained': 'stripped-retained',
                    'Stripped':            'stripped',
                    'Blunt End':           'blunt-end',
                };
                const endTypeValue = valueMap[ endType ] ?? endType;
                jQuery( '#right-end-type' ).val( endTypeValue ).trigger( 'change' );
                await wait( 200 );
            }

            if ( data['Right Strip Length'] ) {
                jQuery( '#right-strip-length' ).val( data['Right Strip Length'] );
                this.selection.rightStripLength = parseFloat( data['Right Strip Length'] );
            }
        }

        const leftShrink = data['Left Heatshrink'] || null;
        if ( leftShrink ) {
            const shrinkId = this.findShrinkIdByPartNumber( leftShrink );
            if ( shrinkId ) {
                jQuery( '#leftshrink' ).val( shrinkId ).trigger( 'change' );
                await wait( 600 );
            }
        }

        const rightShrink = data['Right Heatshrink'] || null;
        if ( rightShrink ) {
            const shrinkId = this.findShrinkIdByPartNumber( rightShrink );
            if ( shrinkId ) {
                jQuery( '#rightshrink' ).val( shrinkId ).trigger( 'change' );
                await wait( 600 );
            }
        }

        if ( data['Quantity'] ) {
            jQuery( '#quantity' ).val( data['Quantity'] ).trigger( 'change' );
        }

        jQuery( 'input[name="options[]"]' ).each( function() {
            const label   = jQuery( this ).val();
            const checked = data[ label ] === 'Yes';
            jQuery( this ).prop( 'checked', checked );
        } );

        //make sure this is in sync with the select
        jQuery( '.s-unit' ).text( jQuery( '#measure' ).val() );

        if ( data['Right End Type'] ) {
            const endType = data['Right End Type'];
            jQuery( '#right-end-type' ).val( endType ).trigger( 'change' );
            this.selection.rightEndType = endType;
            await wait( 200 );
        }

        if ( data['Right Strip Length'] ) {
            jQuery( '#right-strip-length' ).val( data['Right Strip Length'] );
            this.selection.rightStripLength = parseFloat( data['Right Strip Length'] );
        }

        jQuery( '#done, #done-2' ).prop( 'disabled', false );
        Configurator.currentStep = 3;
        Configurator.goToSlide( 1 );
        Configurator.updatePageIndicator( 3 );
        Configurator.updateSlideStates( 3 );
    },

    findLugIdByPartNumber(partNumber) {
        const lug = Object.values(VendorData.lugOptions).find(l => l.part_number === partNumber);
        return lug ? lug.id : null;
    },

    findShrinkIdByPartNumber(partNumber) {
        const hs = Object.values(VendorData.products.heatshrinks).find(h => h.part_number === partNumber);
        return hs ? hs.id : null;
    },

    async debugPreset() {
    const params = new URLSearchParams( window.location.search );
    if ( ! params.has( 'debug' ) ) return;

    const gauge      = params.get( 'gauge' )       ?? null;
    const color      = params.get( 'color' )       ?? null;
    const lugLeft    = params.get( 'lugleft' )     ?? null;
    const lugRight   = params.get( 'lugright' )    ?? null;
    const shrinkLeft  = params.get( 'shrinkleft' ) ?? null;
    const shrinkRight = params.get( 'shrinkright' ) ?? null;

    const wait = ( ms ) => new Promise( resolve => setTimeout( resolve, ms ) );

    if ( gauge ) {
        jQuery( '#gauge' ).val( gauge ).trigger( 'change' );
        await wait( 300 );
    }

    if ( color ) {
        jQuery( '#color' ).val( color ).trigger( 'change' );
        await wait( 300 );
    }

    if ( lugLeft ) {
        jQuery( '#lefttype' ).val( lugLeft ).trigger( 'change' );
        await wait( 600 );
    }

    if ( lugRight ) {
        jQuery( '#righttype' ).val( lugRight ).trigger( 'change' );
        await wait( 600 );
    }

    if ( shrinkLeft ) {
        jQuery( '#leftshrink' ).val( shrinkLeft ).trigger( 'change' );
        await wait( 600 );
    }

    if ( shrinkRight ) {
        jQuery( '#rightshrink' ).val( shrinkRight ).trigger( 'change' );
        await wait( 600 );
    }
},

    

    onSubmitQuote() {

        // Check cart is not empty
        if (!Cart.items || Cart.items.length === 0) {
            this.showQuotePopup(
                'Empty Quote',
                'Please add at least one cable configuration to your quote before submitting.',
                false
            );
            return;
        }

        // Clear previous errors
        jQuery('.s-error').remove();
        jQuery('.s-field-error').removeClass('s-field-error');

        const firstName = jQuery('#firstname').val().trim();
        const lastName  = jQuery('#lastname').val().trim();
        const email     = jQuery('#email').val().trim();
        const phone     = jQuery('#phone').val().trim();
        const company   = jQuery('#company').val().trim();
        const state     = jQuery('#state').val();
        const preferred = jQuery('input[name="preferred_contact"]:checked').val();
        const sendEmail = jQuery('#send-email').is(':checked');
        const notes     = jQuery('#notes').val()?.trim() || '';

        let valid = true;

        if (!firstName) {
            this.showFieldError('#firstname', 'First name is required.');
            valid = false;
        }

        if (!lastName) {
            this.showFieldError('#lastname', 'Last name is required.');
            valid = false;
        }

        if (!email) {
            this.showFieldError('#email', 'Email address is required.');
            valid = false;
        } else if (!this.isValidEmail(email)) {
            this.showFieldError('#email', 'Please enter a valid email address.');
            valid = false;
        }

        if (!valid) return;

        const payload = {
            first_name:        firstName,
            last_name:         lastName,
            email:             email,
            phone:             phone,
            company:           company,
            state:             state,
            preferred_contact: preferred,
            send_email:        sendEmail,
            notes:             notes,
        };

        jQuery('#submit-quote').prop('disabled', true).text('Submitting...');

        jQuery.ajax({
            url:         VendorData.apiBase + '/cart/submit-quote',
            method:      'POST',
            contentType: 'application/json',
            headers:     { 'X-WP-Nonce': VendorData.restNonce ?? '' },
            xhrFields:   { withCredentials: true },
            data:        JSON.stringify(payload),
            success: (response) => {
                if (response.success) {
                    this.onQuoteSuccess(response.order_id);
                }
            },
            error: (xhr) => {
                jQuery('#submit-quote').prop('disabled', false).text('Submit Quote');
                const message = xhr.responseJSON?.message || 'Failed to submit quote. Please try again.';
                jQuery('.cart-submit-quote .s-form').prepend(
                    `<div class="s-error s-error--global">${message}</div>`
                );
            },
        });
    },

    onQuoteSuccess(orderId) {
        this.showQuotePopup(VendorData.thankYouMessage || '', true, orderId);

        // Reset and hide form
        this.resetForm();
        jQuery('.cart-submit-quote').addClass('hidden');
        jQuery('.cart-preview h3').show();
        jQuery('.cart-right').show();
        jQuery( '#submit-quote' ).prop( 'disabled', false ).text( 'Submit Quote' );
        jQuery('#cable-added-to-cart').addClass('hidden');
            jQuery('#reset').removeClass('hidden');
            jQuery('.number').removeClass('current');
             

        setTimeout(() => {
            Cart.isDirty  = true;
            Cart.items    = [];
            Cart.cartHash = null;
            
            /* Force re-init of WooCommerce session via a lightweight ping */
            jQuery.ajax( {
                url:      VendorData.ajaxUrl,
                method:   'POST',
                xhrFields: { withCredentials: true },
                data:     { action: 'winar_reset_session' },
            } ).always( () => {
                Cart.fetchAndRender();
            } );

        }, 500);
    },

    showQuotePopup(content, success, orderId = null) {
        jQuery('.quote-popup').remove();
        
        const errorContent = `
            <h2 class="quote-popup__title">Empty Quote</h2>
            <p class="quote-popup__message">${content}</p>
        `;

        const popup = `
            <div class="quote-popup">
                <div class="quote-popup__box">
                    <div class="quote-popup__box-inner">
                        ${success ? content : errorContent}
                        <div class="quote-popup__icon ${success ? 'is-success' : 'is-error'}"></div>
                        <button class="quote-popup__btn button" id="quote-popup-close">
                            ${success ? 'Back to Site' : 'OK'}
                        </button>
                    </div>
                </div>
            </div>
        `;

        jQuery('body').append(popup);

        jQuery('#quote-popup-close').on('click', () => {
            jQuery('.quote-popup').remove();
            if (success) {
                jQuery('body').removeClass('cart-open');
            }
        });
    },

    showFieldError(fieldId, message) {
        jQuery(fieldId).addClass('s-field-error');
        jQuery(fieldId).closest('.s-item').find('.s-error').remove();
        jQuery(fieldId).closest('.s-item').append(
            `<span class="s-error">${message}</span>`
        );
    },

    isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
};

export default ConfiguratorForm;